export const ERROR_REFETCH_MESSAGE = 'Already in progress';
export const PROMISE_NAME = 'data';
export const MANIPULATION_NAME = 'manipulation';
